import React from "react";

const AttendanceRulesTab = ({ darkMode }) => {
  return (
    <div>
      <h3
        className={`text-lg font-semibold mb-4 ${
          darkMode ? "text-white" : "text-gray-800"
        }`}
      >
        Attendance Rules
      </h3>
      <p className={`${darkMode ? "text-gray-300" : "text-gray-600"}`}>
        Configure attendance rules and policies.
      </p>
    </div>
  );
};

export default AttendanceRulesTab;
